import appState from './containers/template/AppReducer';

export default {
    appState,
};



// WEBPACK FOOTER //
// ./src/reducers.js